import { render, staticRenderFns } from "./DynamicParameter.vue?vue&type=template&id=60d636d4&"
import script from "./DynamicParameter.vue?vue&type=script&lang=ts&"
export * from "./DynamicParameter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports